import React, { FunctionComponent } from 'react';
import { isMobileView } from '../utils/utils';
import classes from './SignUpPageLayout.module.css';

interface Props {
  navigationBar?: React.ReactNode;
  centerDesktop?: React.ReactNode;
}

export const SignUpPageLayout: FunctionComponent<Props> = ({
  navigationBar,
  centerDesktop,
}) => (
  <div
    style={{ userSelect: 'none' }}
    className={!isMobileView() ? classes.myDiv : classes.myDivSiteStub}
  >
    {!isMobileView() && (
      <div className={classes.container}>
        <div className={classes.elementBar}>{navigationBar}</div>
        <div className={classes.elementCenter}>{centerDesktop}</div>
      </div>
    )}
  </div>
);

SignUpPageLayout.defaultProps = {
  navigationBar: undefined,
  centerDesktop: undefined,
};
